export const eventStatuses = ["scheduled", "completed", "cancelled"];
export const eventStatusLabels = {
    scheduled: "Scheduled",
    completed: "Completed",
    cancelled: "Cancelled",
};
export const rsvpResponses = ["yes", "maybe", "no"];
export const rsvpResponseLabels = {
    yes: "Yes",
    maybe: "Maybe",
    no: "No",
};
export const rsvpSources = ["guest", "advisor"];
export const maxBulkInvitees = 200;
export const eventDurationOptionsMinutes = [15, 30, 45, 60, 90, 120, 180, 240];
export const rsvpCodeAlphabet = "abcdefghjkmnpqrstuvwxyz23456789";
export const rsvpCodeLength = 12;
export const isRsvpCode = (value) => value.length === rsvpCodeLength &&
    value.split("").every(character => rsvpCodeAlphabet.includes(character));
export const isRsvpResponse = (value) => rsvpResponses.includes(value);
export const isEventStatus = (value) => eventStatuses.includes(value);
export const normalizeRsvpNote = (note) => {
    const trimmed = (note ?? "").trim();
    return trimmed === "" ? null : trimmed;
};
export const invitationDeliveryStatuses = [
    "sent",
    "delivered",
    "opened",
    "bounced",
    "complained",
];
export const invitationDeliveryStatusLabels = {
    sent: "Sent",
    delivered: "Delivered",
    opened: "Opened",
    bounced: "Bounced",
    complained: "Marked as spam",
};
export const maxAdditionalGuests = 9;
export const normalizeAdditionalGuests = (response, additionalGuests) => {
    if (response === "no") {
        return 0;
    }
    return Math.min(maxAdditionalGuests, Math.max(0, Math.floor(additionalGuests)));
};
//# sourceMappingURL=event.js.map